import { HeaderSectionStyle } from '@website-builder/model/structure/section/header-section-style';
import { Section } from '@website-builder/model/structure/section/section';
import { NavbarConfig } from '@website-builder/model/structure/section/navbar-config';
import { Row } from '@website-builder/model/structure/row/row';
import { WidgetNormalizer } from '@website-builder/widgets/normalizer/widget-normalizer';
import { VideoWidget } from '@website-builder/widgets/video/video-widget';

export class HeaderSection extends Section {
  readonly subtype = 'header-section';
  style = new HeaderSectionStyle();
  navbar = new NavbarConfig();

  static normalizeInPlace(section: Partial<HeaderSection>): HeaderSection {
    const pureSection = new HeaderSection();

    section.sideTitle = section.sideTitle ?? pureSection.sideTitle;
    section.id = section.id ?? pureSection.id;
    section.rows = (section.rows ?? []).map(row => Row.normalizeInPlace(row));
    section.name = section.name ?? pureSection.name;
    section.src = section.src ?? pureSection.src;
    section.video = section.video
      ? (WidgetNormalizer.normalizeInPlace(section.video) as VideoWidget)
      : pureSection.video;
    section.parentType = section.parentType ?? pureSection.parentType;

    section.style = HeaderSectionStyle.normalize(section.style);
    section.navbar = NavbarConfig.normalize(section.navbar);

    return section as HeaderSection;
  }
}
